import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const AnimationWrapper = ({
  isShowing = false,
  onShowClassName,
  onHideClassName,
  children,
}) => {
  const [shouldRender, setShouldRender] = useState(isShowing);

  useEffect(() => {
    if (isShowing) setShouldRender(true);
  }, [isShowing]);

  const onAnimationEnd = () => {
    if (!isShowing) setShouldRender(false);
  };

  return (
    shouldRender && (
      <div
        className={classnames({
          [onShowClassName]: isShowing,
          [onHideClassName]: !isShowing,
        })}
        onAnimationEnd={onAnimationEnd}
      >
        {children}
      </div>
    )
  );
};

AnimationWrapper.propTypes = {
  isShowing: PropTypes.bool,
  onShowClassName: PropTypes.string.isRequired,
  onHideClassName: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default AnimationWrapper;
